import { SET_CURRENT_AREA } from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.current, action = {type: ''}) => {
    switch (action.type) {
        case SET_CURRENT_AREA:
            return action.payload;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/currentArea.js